import { render, staticRenderFns } from "./SchoolSubjectUpload.vue?vue&type=template&id=e0aa8464&"
import script from "./SchoolSubjectUpload.vue?vue&type=script&lang=ts&"
export * from "./SchoolSubjectUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports